import { Router } from '@angular/router';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import saveAs from 'file-saver';
import { MenuItem, MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { DepartmentAppVerificationModel } from 'src/app/models/department-app-verification.model';
import { Table } from 'primeng/table';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { BankDetail } from '../../registration/bank-details/bankDetails';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
@Component({
  selector: 'app-realtime-data-pdmc-scheme',
  templateUrl: './realtime-data-pdmc-scheme.component.html',
  styleUrls: ['./realtime-data-pdmc-scheme.component.scss']
})
export class RealtimeDataPdmcSchemeComponent implements OnInit {
  // @ViewChild('appVerificationTable', { static: true })
  // public appVerificationTable: Table;
  @ViewChild('realtimeDataPdmcSchemeTable', { static: true }) public realtimeDataPdmcSchemeTable;
  @ViewChild('realtimeDataPdmcScheme2Table', { static: true }) public realtimeDataPdmcScheme2Table;
  addBankDialog: boolean;
  fileName = 'ExcelSheet.xlsx';
  bankAccountList: BankDetail[] = [];

  bankAccount: BankDetail;

  selectedBankAccounts: BankDetail[];

  submitted: boolean;
  districtConsistencyItems: MenuItem[];
  onFarmerWaterTankItesms: MenuItem[];
  vendorEstVerificationItems: MenuItem[];

  statuses: any[];
  cols: (
    | { field: string; header: string; customExportHeader: string }
    | { field: string; header: string; customExportHeader?: undefined }
  )[];
  exportColumns: { title: string; dataKey: string }[];
  farmerId: any;
  bankList: any;
  filteredBankList: any[];
  appVerificationModel: DepartmentAppVerificationModel[];
  miDetailsByAppId: any;
  _appID: any;

  ipAddress: any;
  public userID: any;
  public status: any;
  districtConsistencyList: any[];
  // canalTubewellReportList: any[];
  canalTubewellList: any;
  finalArray = [];
  disctrictConsistenceWiseData: any;
  realTimeSoucreListData: any;
  // tempArray =
  constructor(
    private messageService: MessageService,
    private deptDashBoardService: DepartmentDashboardService,
    private router: Router,
    private dashboard: DashboardService,
    private cryptoJsService: CryptoJsService,
    private activityRecordService: ActivityRecordService,
    public cd: ChangeDetectorRef
  ) { }

  ngOnInit() {
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;
    this.loadData();
    // this.realtimeDataPdmcSchemeTable.filters['Status_Ar'] = [
    //   { value: '', matchMode: 'startsWith', operator: 'and' },
    // ];
    // this.realtimeDataPdmcScheme2Table.filters['Status_Ar'] = [
    //   { value: '', matchMode: 'startsWith', operator: 'and' },
    // ];
    
    this.districtConsistencyItems = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcelforDistrictandconstituency(this.disctrictConsistenceWiseData, 'Real time data of PDMC Scheme District and constituency wise detail');
        },
      },
      {
        label: 'Download Pdf',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.downloadSheetAsPdf(
            this.disctrictConsistenceWiseData,
            'Real time data of PDMC Scheme District and constituency wise detail'
          );
        },
      },
    ];
    this.onFarmerWaterTankItesms = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcelforOnFarmerTank(this.realTimeSoucreListData, 'On Farm Water Tank (Other Intervention component)');
        },
      },
      {
        label: 'Download Pdf',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.downloadSheetAsPdf1(
            this.realTimeSoucreListData,
            'On Farm Water Tank (Other Intervention component)'
          );
        },
      },
    ];
  }

  onFiltering(event: any) {
  }

  loadData() {
    this.deptDashBoardService.GetMicroIrrigationSystem().pipe(first()).subscribe({
      next: (data) => {
        this.canalAndTubeWellBasedReport(data)
        this.consistenceWisedDataCalculation(data)
        this.cd.detectChanges();
        this.cd.reattach()
      },
      error: (err) => {
        this.activityRecordService.activityRecord(this.userID, 'District and consistence wise data on clicking For Approval', '', new Date(), err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail: 'Data error! District and consistence wise data on clicking not loaded.',
        });
      },
    });
  }
  canalAndTubeWellBasedReport(data) {
    let waterSourceObj = {}
    this.canalTubewellList = data;
    for (let index = 0; index < this.canalTubewellList.length; index++) {
      if (waterSourceObj[this.canalTubewellList[index].Source_Name]) {
        waterSourceObj[this.canalTubewellList[index].Source_Name].push(this.canalTubewellList[index])
      } else if (!waterSourceObj[this.canalTubewellList[index].Source_Name]) {
        waterSourceObj[this.canalTubewellList[index].Source_Name] = []
        waterSourceObj[this.canalTubewellList[index].Source_Name].push(this.canalTubewellList[index])
      }
    }
    let waterSourceArray = Object.keys(waterSourceObj)
    let waterSourceWisedData = [];
    for (let index = 0; index < waterSourceArray.length; index++) {
      let waterSourceArrayList = waterSourceObj[waterSourceArray[index]]
      let verifiedAreaCount = 0;
      let incompleteAreaCount = 0;
      let verifiedApps = 0;
      let subsidyDisbursedDate = 0;
      let disbursedAmount = 0;
      let Area = 0;
      let Source_Name: any;
      let incomplete = 0
      let subsidyDisbursedDateCount = 0
      for (let l = 0; l < waterSourceArrayList.length; l++) {
          Source_Name = waterSourceArrayList[l].Source_Name
          if (waterSourceArrayList[l].TotalArea) {
            Area = Area + (waterSourceArrayList[l].TotalArea ? waterSourceArrayList[l].TotalArea : 0)
          }
          if (waterSourceArrayList[l].Status_Ar == 'A') {
            verifiedApps = verifiedApps + 1
            verifiedAreaCount = verifiedAreaCount + (waterSourceArrayList[l].TotalArea ? waterSourceArrayList[l].TotalArea : 0)
          }
          if ((waterSourceArrayList[l].Status_Ar == 'CP') || (waterSourceArrayList[l].Status_Ar == 'RP')) {
            incompleteAreaCount = incompleteAreaCount + (waterSourceArrayList[l].TotalArea ? waterSourceArrayList[l].TotalArea : 0)
            incomplete  = incomplete + 1
          }
          if (waterSourceArrayList[l].Stage3DisbursedDate) {
            subsidyDisbursedDate = subsidyDisbursedDate + (waterSourceArrayList[l]).length
            subsidyDisbursedDateCount = subsidyDisbursedDate + 1
          }
          if(waterSourceArrayList[l].stage3DisbursedAmount) {
            disbursedAmount = disbursedAmount + (waterSourceArrayList[l].DisbursedAmount ? waterSourceArrayList[l].DisbursedAmount : 0)
          }
      }
      const Obj = {
        Source_Name: Source_Name,
        Verified_Apps : verifiedApps,
        Verified_Area_Count: verifiedAreaCount ? verifiedAreaCount.toFixed(2) : 0,
        Under_Process_of_Installation : incomplete ? incomplete.toFixed(2) : 0,
        Under_Process_Area : incompleteAreaCount ? incompleteAreaCount.toFixed(2) : 0,
        Assistance_Disbursed : subsidyDisbursedDateCount,
        Disbursed_Area: subsidyDisbursedDate,
        Disbursed_Amount: disbursedAmount,
        Noof_Benficiaries : verifiedApps
      }
      waterSourceWisedData.push(Obj);
    }
    waterSourceWisedData.forEach(e=>{
      e.Under_Process_Area=parseFloat(e.Under_Process_Area)
      e.Under_Process_of_Installation=parseFloat(e.Under_Process_of_Installation);
      e.Verified_Area_Count=parseFloat(e.Verified_Area_Count)
    })
    this.realTimeSoucreListData = waterSourceWisedData
    this.cd.detectChanges();
    this.cd.reattach()
  }
  consistenceWisedDataCalculation(data) {
    let constitutionsObj = {}
    if (data && data.length > 0) {
      this.districtConsistencyList = data
      for (let index = 0; index < this.districtConsistencyList.length; index++) {
        if (constitutionsObj[this.districtConsistencyList[index].Constituency]) {
          constitutionsObj[this.districtConsistencyList[index].Constituency].push(this.districtConsistencyList[index])
        } else if (!constitutionsObj[this.districtConsistencyList[index].Constituency]) {
          constitutionsObj[this.districtConsistencyList[index].Constituency] = []
          constitutionsObj[this.districtConsistencyList[index].Constituency].push(this.districtConsistencyList[index])
        }
      }
      let constitutionkeysArray = Object.keys(constitutionsObj)
      let tempConsistenceWisedData = [];
      for (let index = 0; index < constitutionkeysArray.length; index++) {
        let constituteArrayList = constitutionsObj[constitutionkeysArray[index]]
        let statusArray = {}
        let verifiedAreaCount = 0;
        let incompleteAreaCount = 0;
        let IntimationStage1 = 0;
        let VerifiedStage1 = 0;
        let IntimationStage2 = 0;
        let VerifiedStage2 = 0;
        let AssistanceDisbursedArea1 = 0
        let AssistanceDisbursedAmount1 = 0
        let AssistanceDisbursedArea2 = 0
        let AssistanceDisbursedAmount2 = 0
        let AssistanceDisbursedArea3 = 0
        let AssistanceDisbursedAmount3 = 0
        let IntimationStage3 = 0
        let VerifiedStage3 = 0
        let source_id : any;
        let Area = 0
        for (let l = 0; l < constituteArrayList.length; l++) {
          if (statusArray[constituteArrayList[l].Status_Ar]) {
            source_id = constituteArrayList[l].Source_ID
            if (constituteArrayList[l].APP_ID) {
              statusArray[constituteArrayList[l].Status_Ar].push(constituteArrayList[l])
            }
            if (constituteArrayList[l].TotalArea) {
              Area = Area + (constituteArrayList[l].TotalArea ? constituteArrayList[l].TotalArea : 0)
            }
            if (constituteArrayList[l].Status_Ar == 'A') {
              verifiedAreaCount = verifiedAreaCount + (constituteArrayList[l].TotalArea ? constituteArrayList[l].TotalArea : 0)
            } if ((constituteArrayList[l].Status_Ar == 'CP') || (constituteArrayList[l].Status_Ar == 'RP')) {
              incompleteAreaCount = incompleteAreaCount + (constituteArrayList[l].TotalArea ? constituteArrayList[l].TotalArea : 0)
            }
            if (constituteArrayList[l].Stage1Intimation) {
              IntimationStage1 = IntimationStage1 + 1
            }
            if (constituteArrayList[l].stage1_VerifiedDate) {
              VerifiedStage1 = VerifiedStage1 + 1
            }
            if (constituteArrayList[l].Stage2Intimation) {
              IntimationStage2 = IntimationStage2 + 1
            }
            if (constituteArrayList[l].stage2_VerifiedDate) {
              VerifiedStage2 = VerifiedStage2 + 1
            }
            if (constituteArrayList[l].Stage3Intimation) {
              IntimationStage3 = IntimationStage3 + 1
            }
            if (constituteArrayList[l].stage3_VerifiedDate) {
              VerifiedStage3 = VerifiedStage3 + 1
            }
            if (constituteArrayList[l].Stage1DisbursedDate) {
              AssistanceDisbursedArea1 = AssistanceDisbursedArea1 + 1
            }
            if (constituteArrayList[l].stage1DisbursedAmount) {
              AssistanceDisbursedAmount1 = AssistanceDisbursedAmount1 + (constituteArrayList[l].TotalArea ? constituteArrayList[l].TotalArea : 0)
            }
            if (constituteArrayList[l].Stage2DisbursedDate) {
              AssistanceDisbursedArea2 = AssistanceDisbursedArea2 + 1
            }
            if (constituteArrayList[l].stage2DisbursedAmount) {
              AssistanceDisbursedAmount2 = AssistanceDisbursedAmount2 + (constituteArrayList[l].TotalArea ? constituteArrayList[l].TotalArea : 0)
            }
            if (constituteArrayList[l].Stage3DisbursedDate) {
              AssistanceDisbursedArea3 = AssistanceDisbursedArea3 + 1
            }
            if (constituteArrayList[l].stage3DisbursedAmount) {
              AssistanceDisbursedAmount3 = AssistanceDisbursedAmount3 + (constituteArrayList[l].TotalArea ? constituteArrayList[l].TotalArea : 0)
            }
          } else {
            statusArray[constituteArrayList[l].Status_Ar] = []
            if (constituteArrayList[l].APP_ID) {
              statusArray[constituteArrayList[l].Status_Ar].push(constituteArrayList[l])
            }
            if (constituteArrayList[l].TotalArea) {
              Area = Area + (constituteArrayList[l].TotalArea ? constituteArrayList[l].TotalArea : 0)
            }
            if (constituteArrayList[l].Status_Ar == 'A') {
              verifiedAreaCount = verifiedAreaCount + (constituteArrayList[l].TotalArea ? constituteArrayList[l].TotalArea : 0)
            }
            if ((constituteArrayList[l].Status_Ar == 'CP') || (constituteArrayList[l].Status_Ar == 'RP')) {
              incompleteAreaCount = incompleteAreaCount + (constituteArrayList[l].TotalArea ? constituteArrayList[l].TotalArea : 0)
            }
            if (constituteArrayList[l].Stage1Intimation) {
              IntimationStage1 = IntimationStage1 + 1
            }
            if (constituteArrayList[l].stage1_VerifiedDate) {
              VerifiedStage1 = VerifiedStage1 + 1
            }
            if (constituteArrayList[l].Stage2Intimation) {
              IntimationStage2 = IntimationStage2 + 1
            }
            if (constituteArrayList[l].stage2_VerifiedDate) {
              VerifiedStage2 = VerifiedStage2 + 1
            }
            if (constituteArrayList[l].Stage3Intimation) {
              IntimationStage3 = IntimationStage3 + 1
            }
            if (constituteArrayList[l].stage3_VerifiedDate) {
              VerifiedStage3 = VerifiedStage3 + 1
            }
            if (constituteArrayList[l].Stage1DisbursedDate) {
              AssistanceDisbursedArea1 = AssistanceDisbursedArea1 + 1
            }
            if (constituteArrayList[l].stage1DisbursedAmount1) {
              AssistanceDisbursedAmount1 = AssistanceDisbursedAmount1 + (constituteArrayList[l].TotalArea ? constituteArrayList[l].TotalArea : 0)
            }
            if (constituteArrayList[l].Stage2DisbursedDate) {
              AssistanceDisbursedArea2 = AssistanceDisbursedArea2 + 1
            }
            if (constituteArrayList[l].stage2DisbursedAmount) {
              AssistanceDisbursedAmount2 = AssistanceDisbursedAmount2 + (constituteArrayList[l].TotalArea ? constituteArrayList[l].TotalArea : 0)
            }
            if (constituteArrayList[l].Stage3DisbursedDate) {
              AssistanceDisbursedArea3 = AssistanceDisbursedArea3 + 1
            }
            if (constituteArrayList[l].stage3DisbursedAmount) {
              AssistanceDisbursedAmount3 = AssistanceDisbursedAmount3 + (constituteArrayList[l].TotalArea ? constituteArrayList[l].TotalArea : 0)
            }
          }
        }
        const Obj = {
          Application_recevied: constituteArrayList.length,
          District: constituteArrayList[0].District,
          Constituency: constituteArrayList[0].Constituency,
          Area: Area,
          Approved: statusArray['A'] ? statusArray['A'].length : 0,
          Rejected: statusArray['R'] ? statusArray['R'].length : 0,
          Pending: statusArray['P'] ? statusArray['P'].length : 0,
          Incomplete: (statusArray['CP'] ? statusArray['CP'].length : 0) + (statusArray['RP'] ? statusArray['RP'].length : 0),
          Verified_Area_Count: verifiedAreaCount,
          Incomplete_Area_count: incompleteAreaCount,
          IntimationStage1 : IntimationStage1,
          VerifiedStage1: VerifiedStage1,
          IntimationStage2 : IntimationStage2,
          VerifiedStage2: VerifiedStage2,
          IntimationStage3 : IntimationStage3,
          VerifiedStage3: VerifiedStage3,
          Assistance_Disbursed_Stage1 : AssistanceDisbursedArea1,
          Disbursed_Amount_Stage1 : AssistanceDisbursedAmount1,
          Assistance_Disbursed_Stage2 : AssistanceDisbursedArea2,
          Disbursed_Amount_Stage2 : AssistanceDisbursedAmount2,
          Assistance_Disbursed_Stage3 : AssistanceDisbursedArea3,
          Disbursed_Amount_Stage3 : AssistanceDisbursedAmount3,
          NoofBeneficiary : statusArray['A'] ? statusArray['A'].length : 0,
        }
        tempConsistenceWisedData.push(Obj)
      }
      this.disctrictConsistenceWiseData = tempConsistenceWisedData
      this.cd.detectChanges();
      this.cd.reattach()
    }

  }
  refreshTable() {
    sessionStorage.removeItem('DistrictandconsistencewisedataonclickingApproval');
    this.loadData();
  }

  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      { field: 'District', header: 'District' },
      { field: 'Constituency', header: 'Constituency' },
      { field: 'Application_recevied', header: 'Application recevied' },
      { field: 'Area', header: 'Area' },
      { field: 'Approved', header: 'Verified App' },
      { field: 'Verified_Area_Count', header: 'Verified Area' },
      { field: 'Incomplete', header: 'Incomplete App' },
      { field: 'Rejected', header: 'Rejected App' },
      { field: 'Pending', header: 'Pending App' },
      { field: 'IntimationStage1', header: 'Intimation for earthwork completion (Stage-1)' },
      { field: 'VerifiedStage1', header: 'Verified (Stage-1) Subsidy' },
      { field: 'IntimationStage2', header: 'Intimation for civil construction completion (Stage-2)' },
      { field: 'VerifiedStage2', header: 'Verified (Stage-2) Subsidy' },
      { field: 'IntimationStage3', header: 'Intimation for installation of MI system (Stage-3)' },
      { field: 'VerifiedStage3', header: 'Verified (Stage-3) Subsidy' },
      { field: 'Assistance_Disbursed_Stage1', header: 'Assistance Disbursed Stage-1' },
      { field: 'Disbursed_Amount_Stage1', header: 'Amount' },
      { field: 'Assistance_Disbursed_Stage2', header: 'Assistance Disbursed Stage-2' },
      { field: 'Disbursed_Amount_Stage2', header: 'Amount' },
      { field: 'Assistance_Disbursed_Stage3', header: 'Assistance Disbursed Stage-3' },
      { field: 'Disbursed_Amount_Stage3', header: 'Amount' },
      { field: '', header: 'No. of Benficiary' }
    ];

    this.exportColumns = this.cols.map((col) => ({
      title: col.header,
      dataKey: col.field,
    }));

    import('jspdf').then((jsPDF) => {
      import('jspdf-autotable').then((x) => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData, {styles: {fontSize: 6 }});
        doc.save(`${filename}.pdf`);
      });
    });
  }

  hideDialog() {
    this.addBankDialog = false;
    this.submitted = false;
  }

  printForm(appId, statusCode) {
    if (appId) {
      this.dashboard
        .getMIDetailByAppID(appId)
        .pipe(first())
        .subscribe({
          next: (res) => {
            let statusCodeEncrypted = this.cryptoJsService.Encrypt(statusCode);
            this.router.navigate(
              [
                'department',
                'print',
                this.cryptoJsService.Encrypt(appId),
                res[0]?.VendorId,
                res[0]?.ProgId,
                res[0]?.User_ID,
                res[0]?.AutoId,
              ],
              { queryParams: { statusCode: statusCodeEncrypted } }
            );
          },
          error: (err) => {
            this.activityRecordService.activityRecord(this.userID, 'View District and consistence wise data on clicking Approval', appId, new Date(), err);
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: err,
            });
          }
        });
    }
  }

  exportExcelforDistrictandconstituency(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import('xlsx').then((xlsx) => {
      let dataToSave = modelData.map((d: any) => {
        return {
          'District': d.District,
          'Constituency': d.Constituency,
          'Application recevied': d.Application_recevied,
          'Area': d.Area,
          'Verified App': d.Approved,
          'Verified Area': d.Verified_Area_Count,
          'Incomplete App': d.Incomplete,
          'Rejected App': d.Rejected,
          'Pending App': d.Pending,
          'Intimation for earthwork completion (Stage-1)': d.IntimationStage1,
          'Verified (Stage-1) Subsidy': d.VerifiedStage1,
          'Intimation for civil construction completion (Stage-2)': d.IntimationStage2,
          'Verified (Stage-2) Subsidy': d.VerifiedStage2,
          'Intimation for installation of MI system (Stage-3)': d.IntimationStage3,
          'Verified (Stage-3) Subsidy': d.VerifiedStage3,
          'Assistance Disbursed Stage-1': d.Assistance_Disbursed_Stage1,
          'Assistance Disbursed Stage-1 Amount': d.Disbursed_Amount_Stage1,
          'Assistance Disbursed Stage-2': d.Assistance_Disbursed_Stage2,
          'Assistance Disbursed Stage-2 Amount': d.Disbursed_Amount_Stage2,
          'Assistance Disbursed Stage-3': d.Assistance_Disbursed_Stage3,
          'Assistance Disbursed Stage-3 Amount': d.Disbursed_Amount_Stage3,
          'No. of Benficiary':  d.Disbursed_Amount_Stage3
        };
      });
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  exportExcelforOnFarmerTank(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import('xlsx').then((xlsx) => {
      let dataToSave = modelData.map((d: any) => {
        return {
          "Water Source" : d.Source_Name,
          'Application Verified and Eligible for Assistance': d.Verified_Apps,
          'MI Area (In Acre)': d.Verified_Area_Count,
          'Application under process of Installation': d.Under_Process_of_Installation,
          'Area (In Acre)' : d.Under_Process_Area,
          'Assistance disbursed': d.Assistance_Disbursed,
          'Assistance disbursed Area (In Acre)': d.Area,
          'Amount (Rs. In lakh)': d.Disbursed_Amount,
          'No. of Beneficiary': d.Noof_Benficiaries,
        };
      });
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  downloadSheetAsPdf1(modelData, filename) {
    this.cols = [
      { field: 'Source_Name', header: 'Water Source' },
      { field: 'Verified_Apps', header: 'Application Verified and Eligible for Assistance' },
      { field: 'Verified_Area_Count', header: 'MI Area (In Acre)' },
      { field: 'Under_Process_of_Installation', header: 'Application under process of Installation' },
      { field: 'Under_Process_Area', header: 'Area (In Acre)' },
      { field: 'Assistance_Disbursed', header: 'Assistance disbursed' },
      { field: 'Area', header: 'Area (In Acre)' },
      { field: 'Disbursed_Amount', header: 'Amount (Rs. In lakh)' },
      { field: 'Noof_Benficiaries', header: 'No. of Beneficiary' },
    ];

    this.exportColumns = this.cols.map((col) => ({
      title: col.header,
      dataKey: col.field,
    }));

    import('jspdf').then((jsPDF) => {
      import('jspdf-autotable').then((x) => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData, {styles: {fontSize: 6 }});
        doc.save(`${filename}.pdf`);
      });
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

  rowBackgroundColor(row) {
    if (row.Status_Ar == 'P') {
      if (row.PendingCompletedDays <= -2) {
        return '#ff8080';
      } else if (row.PendingCompletedDays == -1) {
        return '#ffc966';
      }
    } else if (row.Status_Ar == 'C' || row.Status_Ar == 'A') {
      if (row.PendingCompletedDays >= -1) {
        return '#99e699';
      } else if (row.PendingCompletedDays <= -2) {
        return '#ffb3b3';
      }
    } else return '#ffffff';
  }
}
